export async function handleApiResponse(response) {
    
    //Token inválido ou expirado
    if (response.status === 401 || response.status === 403) {
        // Limpa sessão se necessário
        localStorage.clear();
        sessionStorage.clear();

        window.location.reload();
        return null;
    }

    return response;
}
